import { render, staticRenderFns } from "./ChooseOneTimeDeposit.vue?vue&type=template&id=9291052e&"
import script from "./ChooseOneTimeDeposit.vue?vue&type=script&lang=js&"
export * from "./ChooseOneTimeDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports